import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import { LocaleProvider } from './contexts/LocaleContext';

// Pages
import Home from './pages/Home/Home';
import AInsteinRoutes from './apps/ainstein/routes';
import EunoiaRoutes from './apps/eunoia/routes';
import RoamrRoutes from './apps/roamr/routes';
import VoPubRoutes from './apps/vopub/routes';

function App() {
  return (
    <LocaleProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ainstein/*" element={<AInsteinRoutes />} />
          <Route path="/eunoia/*" element={<EunoiaRoutes />} />
          <Route path="/roamr/*" element={<RoamrRoutes />} />
          <Route path="/vopub/*" element={<VoPubRoutes />} />
        </Routes>
      </Router>
    </LocaleProvider>
  );
}

export default App;
